import { NextRouter, useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export function useNavigationWithQuery() {
  const [routerVal, setRouterVal] = useState<NextRouter>();

  const router = useRouter();

  useEffect(() => {
    setRouterVal(router);
  }, [router]);

  const navigateTo = ({ path, query }: { path: string; query?: object }) => {
    if (path !== 'signout' && routerVal?.query?.relogin)
      delete routerVal?.query?.relogin;
    router.push({
      pathname: `/${path}`,
      query: { ...routerVal?.query, ...query },
    });
  };

  return { navigateTo };
}
